// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const staryu: PokeData = {
  "id": 120,
  "name": "staryu",
  "height": 8,
  "weight": 345,
  "base_experience": 68,
  "types": [
    PokeType.WATER
  ],
  "api_moves": [
    "tackle",
    "water-gun",
    "hydro-pump",
    "surf",
    "psybeam",
    "bubble-beam",
    "psychic",
    "recover",
    "harden",
    "minimize",
    "confuse-ray",
    "light-screen",
    "swift",
    "psywave",
    "rapid-spin",
    "camouflage",
    "cosmic-power",
    "gyro-ball",
    "brine",
    "power-gem",
    "reflect-type"
  ],
  "moves": [
    "tackle",
    "hydro-pump",
    "bubble-beam",
    "psychic",
    "confuse-ray",
    "psywave",
    "brine",
    "aqua-cutter",
    "bubble",
    "life-dew",
    "liquidation",
    "aqua-jet",
    "water-spout"
  ],
  "evolution_chain": {
    "id": 56,
    "item": null,
    "species": [
      {
        "name": "staryu",
        "order": 137,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "starmie",
        "order": 138,
        "types": [
          PokeType.WATER,
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": 120,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "water-stone"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 42.5,
    "speed": 85,
    "ability_power": 70
  },
  "stat_changes": [],
  "catch_rate": 225,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
